import React, { useState, useEffect, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../assets/logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { getVisibleSidebarItems } from "../utils/sidebarAccess";

import { X } from "lucide-react";

export default function Sidebar({ isOpen, setIsOpen }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);

  const navItems = useMemo(
    () => getVisibleSidebarItems(user?.allowedRoutes),
    [user?.allowedRoutes],
  );

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/account/login", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      {/* Mobile Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
      
      <aside className={`fixed inset-y-0 left-0 z-50 transform ${isOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 transition-transform duration-300 ease-in-out md:sticky md:top-0 flex flex-col h-screen overflow-y-auto flex-shrink-0 w-[280px] md:w-[288px] bg-[#6D4E8A] text-white px-[15px] pt-6 pb-16 shadow-[4px_11px_4px_-1px_#0000002B]`}>
        <div className="flex items-center justify-between md:justify-center pb-[22px] px-2 md:px-0">
          <img src={Logo} alt="logo" className="h-8 md:h-auto" />
          <button 
            onClick={() => setIsOpen(false)}
            className="md:hidden text-white/80 hover:text-white"
          >
            <X size={24} />
          </button>
        </div>

      <nav className="flex-1 space-y-[5px]">
        {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.route}
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `w-full flex items-center gap-2.5 pl-8 md:pl-12 py-[13px] font-medium rounded-2xl border transition-colors duration-150 ${
                  isActive
                    ? "bg-white border-[#E8E8E8] text-[#6D4E8A]"
                    : "bg-transparent border-white text-white hover:bg-white/10"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <img
                    src={item.icon}
                    alt={`${item.name} icon`}
                    className={`object-contain ${
                      !isActive ? "brightness-0 invert" : ""
                    }`}
                  />

                  <span>{item.name}</span>
                </>
              )}
            </NavLink>
        ))}
      </nav>

      </aside>
    </>
  );
}
